import { useAuthStore } from '@/store/authStore';

/**
 * Check if the user has an active subscription. Call this before any
 * database write action.
 *
 * Returns true if subscription_status === 'active'. Otherwise redirects
 * to billing and returns false. Per the locked product model, never-paid
 * users (status='inactive') and post-cancel users (status='canceled') are
 * treated identically; past_due users are hard-blocked with no grace period.
 *
 * Usage in form handlers:
 *   if (!checkSubscriptionAccess()) return;
 *   await createDeal.mutateAsync(data);
 */
export function checkSubscriptionAccess(): boolean {
  const profile = useAuthStore.getState().profile;
  if (!profile) return false;

  if (profile.subscription_status === 'active') return true;

  window.location.href = '/settings?tab=billing';
  return false;
}
